'use strict';

customerZone.controller('AboutController', ['$window', 'config', function($window, config){
    var self = this;

    self.version = $window.jimVersion;
    self.config = config;
}]);
